module.exports = __webpack_public_path__ + "img/wechat.c4ce9d06.png";